import Diversity3Icon from "@mui/icons-material/Diversity3";
import type { FC } from "react";
import { useHospitalData } from "../../contexts/HospitalDataProvider";
import { INK } from "../../theme/tokens";
import type { Nurse } from "../../utils/models";
import { InHouseTooltip } from "../InHouseTooltip/InHouseTooltip";

type Props = {
	nurseIdOrNurseObject: Pick<Nurse, "union"> | number | undefined;
};
export const NurseUnionIndicator: FC<Props> = ({ nurseIdOrNurseObject }) => {
	const { getNurseById } = useHospitalData();
	const nurse = typeof nurseIdOrNurseObject === "number" ? getNurseById(nurseIdOrNurseObject) : nurseIdOrNurseObject;
	return nurse?.union ? (
		<InHouseTooltip title={nurse.union}>
			<Diversity3Icon
				sx={{
					fontSize: {
						xs: 12,
						sm: 14,
					},
					color: INK.SECONDARY,
				}}
			/>
		</InHouseTooltip>
	) : null;
};
